// tslint:disable:no-any
import { createStore } from "redux";

import rootReducer from "./reducer";



let store;
export const configureStore = () => {
  const store = createStore(
    rootReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );

  return store;
};

export const getStore = () => store;
